"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectProductByKey = exports.selectProduct = exports.queryProductsRegistry = exports.queryProducts = exports.loadProductsRegistry = exports.loadProducts = exports.injectProductDetailsErrors = exports.injectCustomerProductDetails = exports.injectCardProductData = exports.initialState = exports.default = exports.SELECT_PRODUCT = exports.LOAD_REGISTRY_STARTED = exports.LOAD_REGISTRY_FINISHED = exports.LOAD_REGISTRY_CUSTOMER_ERROR = exports.LOAD_REGISTRY_CARD_ERROR = exports.LOAD_DETAILS_STARTED = exports.LOAD_DETAILS_FINISHED = exports.LOAD_DETAILS_ERROR = exports.INJECT_CARD_DETAILS = exports.API_DUCKS_SELECT_PRODUCT = void 0;
var _immutable = require("immutable");
var _iguazuRest = require("iguazu-rest");
var _iguazuRpc = require("iguazu-rpc");
var _config = _interopRequireDefault(require("./config"));
var _constants = require("./constants");
var _utils = require("./utils");
var _selectors = require("./selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LOAD_REGISTRY_STARTED = '@@axp-product-ducks/LOAD_REGISTRY_STARTED/1.x';
exports.LOAD_REGISTRY_STARTED = LOAD_REGISTRY_STARTED;
const LOAD_REGISTRY_FINISHED = '@@axp-product-ducks/LOAD_REGISTRY_FINISHED/1.x';
exports.LOAD_REGISTRY_FINISHED = LOAD_REGISTRY_FINISHED;
const LOAD_REGISTRY_CARD_ERROR = '@@axp-product-ducks/LOAD_REGISTRY_CARD_ERROR/1.x';
exports.LOAD_REGISTRY_CARD_ERROR = LOAD_REGISTRY_CARD_ERROR;
const LOAD_REGISTRY_CUSTOMER_ERROR = '@@axp-product-ducks/LOAD_REGISTRY_CUSTOMER_ERROR/1.x';
exports.LOAD_REGISTRY_CUSTOMER_ERROR = LOAD_REGISTRY_CUSTOMER_ERROR;
const LOAD_DETAILS_STARTED = '@@axp-product-ducks/LOAD_DETAILS_STARTED/1.x';
exports.LOAD_DETAILS_STARTED = LOAD_DETAILS_STARTED;
const LOAD_DETAILS_FINISHED = '@@axp-product-ducks/LOAD_DETAILS_FINISHED/1.x';
exports.LOAD_DETAILS_FINISHED = LOAD_DETAILS_FINISHED;
const LOAD_DETAILS_ERROR = '@@axp-product-ducks/LOAD_DETAILS_ERROR/1.x';
exports.LOAD_DETAILS_ERROR = LOAD_DETAILS_ERROR;
const INJECT_CARD_DETAILS = '@@axp-product-ducks/INJECT_CARD_DETAILS/1.x';
exports.INJECT_CARD_DETAILS = INJECT_CARD_DETAILS;
const SELECT_PRODUCT = '@@axp-product-ducks/SELECT_PRODUCT';
exports.SELECT_PRODUCT = SELECT_PRODUCT;
const API_DUCKS_SELECT_PRODUCT = 'api/products/SET_ACTIVE';
exports.API_DUCKS_SELECT_PRODUCT = API_DUCKS_SELECT_PRODUCT;
const initialState = (0, _immutable.Map)({
  registry: (0, _immutable.Map)({
    loading: undefined,
    loaded: false,
    cardError: undefined,
    customerError: undefined,
    types: (0, _immutable.Map)()
  }),
  details: (0, _immutable.Map)({
    loading: (0, _immutable.Map)(),
    errors: (0, _immutable.Map)(),
    types: (0, _immutable.Map)()
  }),
  injectedCardData: undefined
});

// eslint-disable-next-line default-param-last -- need initial state if not defined
exports.initialState = initialState;
const reducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case LOAD_REGISTRY_STARTED:
      return state.withMutations(mutable => {
        mutable.setIn(['registry', 'loading'], action.promise);
        mutable.deleteIn(['registry', 'cardError']);
        mutable.deleteIn(['registry', 'customerError']);
      });
    case LOAD_REGISTRY_FINISHED:
      return state.deleteIn(['registry', 'loading']).setIn(['registry', 'loaded'], true).withMutations(mutable => {
        Object.keys(action.registry).forEach(type => {
          mutable.setIn(['registry', 'types', type], action.registry[type]);
        });
      });
    case LOAD_REGISTRY_CARD_ERROR:
      return state.setIn(['registry', 'cardError'], action.error);
    case LOAD_REGISTRY_CUSTOMER_ERROR:
      return state.setIn(['registry', 'customerError'], action.error);
    case LOAD_DETAILS_STARTED:
      return state.withMutations(mutable => {
        action.types.forEach(type => {
          mutable.setIn(['details', 'loading', type], action.promise);
          mutable.deleteIn(['details', 'errors', type]);
        });
      });
    case LOAD_DETAILS_FINISHED:
      return state.withMutations(mutable => {
        action.types.forEach(type => {
          mutable.deleteIn(['details', 'loading', type]);
          mutable.setIn(['details', 'types', type], action[type]);
        });
      });
    case LOAD_DETAILS_ERROR:
      return state.withMutations(mutable => {
        action.types.forEach(type => {
          mutable.deleteIn(['details', 'loading', type]);
          mutable.setIn(['details', 'errors', type], action.error);
        });
      });
    case SELECT_PRODUCT:
      return state.set('selectedProduct', action.productId);
    case API_DUCKS_SELECT_PRODUCT:
      return state.set('selectedProduct', action.id);
    case INJECT_CARD_DETAILS:
      return state.set('injectedCardDetails', {
        productsOrder: action.productsOrder,
        productsList: action.productsList
      });
    default:
      return state;
  }
};
const requestMemberProducts = _ref => {
  let {
    forceFetch,
    accountTokens
  } = _ref;
  return dispatch => dispatch((0, _iguazuRest.loadResource)({
    resource: 'memberProducts',
    id: {},
    forceFetch,
    opts: {
      ...(accountTokens ? {
        headers: {
          account_tokens: accountTokens
        }
      } : {}),
      query: {
        refresh: forceFetch
      }
    }
  }));
};
const requestMemberProductsRegistry = _ref2 => {
  let {
    forceFetch,
    accountTokens
  } = _ref2;
  return (dispatch, getState) => {
    const state = getState();
    const injectedCardDetails = (0, _selectors.getInjectedCardDetails)(state);
    if (injectedCardDetails) {
      return Promise.resolve((0, _utils.mapInjectedCardDetailsToRegistry)(injectedCardDetails));
    }
    return dispatch(requestMemberProducts({
      forceFetch,
      accountTokens
    })).then(response => {
      const cardProductsRegistry = (0, _utils.mapCardProductsRegistry)(response);
      return cardProductsRegistry;
    }).catch(error => {
      dispatch({
        type: LOAD_REGISTRY_CARD_ERROR,
        error
      });

      // resolve with empty response
      return (0, _utils.mapCardProductsRegistry)({});
    });
  };
};
const requestCustomerProductsRegistry = _ref3 => {
  let {
    types,
    forceFetch,
    locale
  } = _ref3;
  return dispatch => {
    if (locale && !(0, _utils.getIsCustomerProductsMarket)(locale)) {
      return Promise.resolve((0, _utils.mapCustomerProductsRegistry)([], types));
    }
    const {
      promise
    } = dispatch((0, _iguazuRpc.queryProcedureResult)({
      procedureName: 'readCustomerProductsV2',
      args: {},
      forceFetch
    }));
    return promise.then(response => {
      if (response instanceof Error) {
        dispatch({
          type: LOAD_REGISTRY_CUSTOMER_ERROR,
          error: response
        });

        // resolve with empty response
        return (0, _utils.mapCustomerProductsRegistry)([], types);
      }
      return (0, _utils.mapCustomerProductsRegistry)(response, types);
    });
  };
};
const requestMemberProductDetails = _ref4 => {
  let {
    forceFetch,
    accountTokens
  } = _ref4;
  return (dispatch, getState) => {
    const state = getState();
    const registryByTypes = (0, _selectors.getProductsRegistry)(state);
    const existingTypes = [_constants.CARD_PRODUCT].filter(type => registryByTypes[type] && registryByTypes[type].length > 0);
    const injectedCardDetails = (0, _selectors.getInjectedCardDetails)(state);
    let promise;
    if (existingTypes.length === 0) {
      promise = Promise.resolve({
        types: [_constants.CARD_PRODUCT],
        [_constants.CARD_PRODUCT]: (0, _utils.mapCardProductDetails)({})
      });
    } else if (injectedCardDetails) {
      promise = Promise.resolve({
        types: [_constants.CARD_PRODUCT],
        [_constants.CARD_PRODUCT]: injectedCardDetails
      });
    } else {
      promise = dispatch(requestMemberProducts({
        forceFetch,
        accountTokens
      })).then(response => {
        const productDetails = (0, _utils.mapCardProductDetails)(response);
        return Promise.resolve({
          types: [_constants.CARD_PRODUCT],
          [_constants.CARD_PRODUCT]: productDetails
        });
      }).catch(error => {
        dispatch({
          type: LOAD_DETAILS_ERROR,
          types: [_constants.CARD_PRODUCT],
          error
        });

        // resolve with empty response
        return Promise.resolve({
          types: [_constants.CARD_PRODUCT],
          [_constants.CARD_PRODUCT]: (0, _utils.mapCardProductDetails)({})
        });
      });
    }
    dispatch({
      type: LOAD_DETAILS_STARTED,
      types: [_constants.CARD_PRODUCT],
      promise
    });
    return promise;
  };
};
const requestCustomerProductDetails = _ref5 => {
  let {
    types,
    forceFetch
  } = _ref5;
  return (dispatch, getState) => {
    const state = getState();
    const registryByTypes = (0, _selectors.getProductsRegistry)(state);
    const existingTypes = types.filter(type => registryByTypes[type] && registryByTypes[type].length > 0);
    let promise;
    if (existingTypes.length === 0) {
      const productData = (0, _utils.mapCustomerProductDetails)({}, types);
      promise = Promise.resolve({
        types,
        ...productData
      });
    } else {
      const args = existingTypes.reduce((accum, type) => ({
        ...accum,
        [type]: {
          accountIds: registryByTypes[type].map(_ref6 => {
            let {
              opaqueAccountId
            } = _ref6;
            return opaqueAccountId;
          })
        }
      }), {});
      const {
        promise: queryPromise
      } = dispatch((0, _iguazuRpc.queryProcedureResult)({
        procedureName: 'readCustomerProductDetailsV1',
        args,
        forceFetch
      }));
      promise = queryPromise.then(response => {
        if (response instanceof Error) {
          dispatch({
            type: LOAD_DETAILS_ERROR,
            types: existingTypes,
            error: response
          });

          // resolve with empty response
          return Promise.resolve({
            types,
            ...(0, _utils.mapCustomerProductDetails)({}, types)
          });
        }

        // track failures but follow through to map what does return
        const {
          failures: productFailures = []
        } = response;
        if (productFailures.length > 0) {
          dispatch({
            type: LOAD_DETAILS_ERROR,
            types: productFailures,
            error: new Error('ReadCustomerProductDetails.v2 partial failure')
          });
        }
        const productData = (0, _utils.mapCustomerProductDetails)(response, types);
        return Promise.resolve({
          types,
          ...productData
        });
      });
    }
    dispatch({
      type: LOAD_DETAILS_STARTED,
      types,
      promise
    });
    return promise;
  };
};
const loadProductsRegistry = function () {
  let {
    forceFetch = false,
    accountTokens,
    locale = ''
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (dispatch, getState) => {
    const state = getState();
    const filterTypes = (0, _selectors.getFilterTypes)(state);
    const loadingPromise = (0, _selectors.getRegistryLoadingPromise)(state);
    const isLoading = !!loadingPromise;
    const registryData = (0, _selectors.getRegistryData)(state);
    const isLoaded = (0, _selectors.getIsRegistryLoaded)(state);
    if (isLoading) {
      return loadingPromise;
    }
    if (!forceFetch) {
      if (isLoaded) {
        return Promise.resolve(registryData);
      }
    }
    const nonCardTypes = filterTypes.filter(type => type !== _constants.CARD_PRODUCT);
    const memberProductsPromise = dispatch(requestMemberProductsRegistry({
      forceFetch,
      accountTokens
    }));
    const customerProductsPromise = dispatch(requestCustomerProductsRegistry({
      types: nonCardTypes,
      forceFetch,
      locale
    }));
    const promise = Promise.all([memberProductsPromise, customerProductsPromise]).then(_ref7 => {
      let [memberProductsRegistry, customerProductsRegistry] = _ref7;
      const productsRegistry = {
        ...memberProductsRegistry,
        ...customerProductsRegistry
      };
      dispatch({
        type: LOAD_REGISTRY_FINISHED,
        registry: productsRegistry
      });

      // get updated state to return all product data
      const updatedState = getState();
      const updatedRegistryData = (0, _selectors.getRegistryData)(updatedState);
      let {
        selectedProduct
      } = updatedRegistryData;

      // set initial selected product after products registry is loaded
      // and use order types config to determine initial selected product
      if (!selectedProduct) {
        const orderTypes = (0, _selectors.getOrderTypes)(updatedState);

        // filter out types without products
        // then types that are not card product and have no active products
        let desiredTypes = orderTypes.filter(type => updatedRegistryData[type] && updatedRegistryData[type].length > 0 && (type === _constants.CARD_PRODUCT || updatedRegistryData[type] && updatedRegistryData[type].some(_ref8 => {
          let {
            status
          } = _ref8;
          return status === 'ACTIVE';
        })));

        // if no types are found with active products, use any type with products
        if (desiredTypes.length === 0) {
          desiredTypes = orderTypes;
        }

        // find the first type with products
        const foundType = desiredTypes.find(type => updatedRegistryData[type] && updatedRegistryData[type].length > 0);
        if (foundType) {
          // find the first card product or first active non card product
          ({
            opaqueAccountId: selectedProduct
          } = updatedRegistryData[foundType].find(_ref9 => {
            let {
              status
            } = _ref9;
            return foundType === _constants.CARD_PRODUCT || status === 'ACTIVE';
          }) || updatedRegistryData[foundType][0]);
          dispatch({
            type: SELECT_PRODUCT,
            productId: selectedProduct
          });
        }
      }
      const finalRegistryData = {
        ...updatedRegistryData,
        selectedProduct
      };
      dispatch(_config.default.onLoadRegistry({
        productId: selectedProduct,
        registryData: finalRegistryData
      }));
      return Promise.resolve(finalRegistryData);
    });
    dispatch({
      type: LOAD_REGISTRY_STARTED,
      promise
    });
    return promise;
  };
};
exports.loadProductsRegistry = loadProductsRegistry;
const queryProductsRegistry = function () {
  let {
    locale
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (dispatch, getState) => {
    const state = getState();
    const registryData = (0, _selectors.getRegistryData)(state);
    const isLoaded = (0, _selectors.getIsRegistryLoaded)(state);
    const data = isLoaded ? registryData : undefined;
    return {
      status: isLoaded ? 'complete' : 'loading',
      promise: dispatch(loadProductsRegistry({
        locale
      })),
      data
    };
  };
};
exports.queryProductsRegistry = queryProductsRegistry;
const loadProducts = function () {
  let {
    types,
    forceFetch = false,
    accountTokens,
    permitPartialLoad = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (dispatch, getState) => {
    const state = getState();

    // filter out requested types by what is permitted
    const filteredTypes = (0, _selectors.getFilteredTypes)(types);

    // get product registry loaded status to warn consumer
    // that registry should be requested before details
    const isRegistryLoaded = (0, _selectors.getIsRegistryLoaded)(state);
    if (!isRegistryLoaded) {
      console.warn('\'loadProducts\' should only be called after \'loadProductsRegistry\'.');
    }
    const productData = (0, _selectors.getData)(state, filteredTypes);
    const {
      selectedProduct: initalSelectedProduct,
      ...productsByTypes
    } = productData;

    // get loaded types
    const loadedTypes = !forceFetch ? Object.keys(productsByTypes).filter(key => filteredTypes.includes(key)) : [];

    // filter loaded types from requested types
    const unloadedTypes = !forceFetch ? filteredTypes.filter(type => !loadedTypes.includes(type)) : filteredTypes;

    // only check loading status from unloaded types
    // as promise is missing before and after loading
    const existingPromises = (0, _selectors.getLoadingPromises)(state, unloadedTypes);
    const isLoading = (0, _selectors.getIsLoading)(state, unloadedTypes);
    const hasError = (0, _selectors.getHasError)(state, filteredTypes, permitPartialLoad);
    const error = (0, _selectors.getError)(state, filteredTypes);
    const isLoaded = (0, _selectors.getIsLoaded)(state, filteredTypes);
    const returnUpdatedData = function () {
      let withHook = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // get updated state to return all product data
      const updatedState = getState();

      // check now if data is incomplete/errored
      const updatedHasError = (0, _selectors.getHasError)(updatedState, filteredTypes, permitPartialLoad);
      const updatedError = (0, _selectors.getError)(updatedState, filteredTypes);
      if (updatedHasError) {
        return Promise.reject(updatedError);
      }
      const updatedProductData = (0, _selectors.getData)(updatedState, filteredTypes);
      if (withHook) {
        const {
          selectedProduct
        } = updatedProductData;
        const locale = (0, _selectors.getProductLocale)(updatedState, selectedProduct);
        dispatch(_config.default.onLoadProducts({
          productId: selectedProduct,
          locale,
          productData: updatedProductData
        }));
      }
      return Promise.resolve(updatedProductData);
    };

    // if every type is loading
    if (isLoading) {
      return Promise.all(existingPromises).then(() => returnUpdatedData());
    }
    if (!forceFetch) {
      // if any type is errored
      if (hasError) {
        return Promise.reject(error);
      }

      // if every type is loaded
      if (isLoaded) {
        return Promise.resolve(productData);
      }
    }

    // separate card from non-card types
    const hasCardType = unloadedTypes.includes(_constants.CARD_PRODUCT);
    const nonCardTypes = unloadedTypes.filter(type => type !== _constants.CARD_PRODUCT);

    // track promises created in this run
    const newPromises = [];
    const handleResponse = _ref10 => {
      let {
        types: responseTypes,
        ...responseData
      } = _ref10;
      return dispatch({
        type: LOAD_DETAILS_FINISHED,
        types: responseTypes,
        ...responseData
      });
    };

    // request card types from Member bDaas API
    if (hasCardType) {
      const cardPromise = dispatch(requestMemberProductDetails({
        forceFetch,
        accountTokens
      })).then(response => handleResponse(response));
      newPromises.push(cardPromise);
    }

    // request all types from readCustomerProducts ONE-DATA API
    if (nonCardTypes.length > 0) {
      const nonCardPromise = dispatch(requestCustomerProductDetails({
        types: nonCardTypes,
        forceFetch
      })).then(response => handleResponse(response));
      newPromises.push(nonCardPromise);
    }

    // make resolving the newly created promises conditional on the existing being resolved
    // so that the new responses cannot be set into state if the previous ones fail
    const promise = Promise.all(existingPromises).then(() => Promise.all(newPromises)).then(() => returnUpdatedData(true));
    return promise;
  };
};
exports.loadProducts = loadProducts;
const queryProducts = function () {
  let {
    types,
    permitPartialLoad
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (dispatch, getState) => {
    // filter out requested types by what is permitted
    const filteredTypes = (0, _selectors.getFilteredTypes)(types);
    const state = getState();
    const isLoaded = (0, _selectors.getIsLoaded)(state, filteredTypes);
    const productData = (0, _selectors.getData)(state, filteredTypes);
    const promise = dispatch(loadProducts({
      types,
      permitPartialLoad
    }));
    const hasError = (0, _selectors.getHasError)(state, filteredTypes, permitPartialLoad);
    const error = (0, _selectors.getError)(state, filteredTypes);
    const data = isLoaded && !hasError ? productData : undefined;
    return {
      status: isLoaded || hasError ? 'complete' : 'loading',
      promise: promise.catch(err => err),
      data: data || error,
      error: hasError ? error : undefined
    };
  };
};
exports.queryProducts = queryProducts;
const selectProduct = productId => (dispatch, getState) => {
  const state = getState();
  const productData = (0, _selectors.getData)(state);
  const locale = (0, _selectors.getProductLocale)(state, productId);
  const shouldContinue = dispatch(_config.default.onBeforeSelectProduct({
    productId,
    locale,
    productData
  }));
  if (shouldContinue) {
    dispatch({
      type: SELECT_PRODUCT,
      productId
    });
    dispatch({
      type: API_DUCKS_SELECT_PRODUCT,
      id: productId
    });
    const updateState = getState();
    const updatedProductData = (0, _selectors.getData)(updateState);
    dispatch(_config.default.onAfterSelectProduct({
      productId,
      locale,
      productData: updatedProductData
    }));
  }
  return Promise.resolve();
};
exports.selectProduct = selectProduct;
const selectProductByKey = key => (dispatch, getState) => {
  const state = getState();
  const selectedProduct = (0, _selectors.getSelectedProduct)(state);
  const productId = (0, _selectors.getAccountTokenByAccountKey)(state, key);
  return productId && productId !== selectedProduct ? dispatch(selectProduct(productId)) : Promise.resolve();
};
exports.selectProductByKey = selectProductByKey;
const injectCardProductData = _ref11 => {
  let {
    productsOrder,
    productsList
  } = _ref11;
  return dispatch => {
    dispatch({
      type: INJECT_CARD_DETAILS,
      productsOrder,
      productsList
    });
  };
};
exports.injectCardProductData = injectCardProductData;
const injectCustomerProductDetails = productDetails => dispatch => dispatch({
  type: LOAD_DETAILS_FINISHED,
  types: Object.keys(productDetails),
  ...productDetails
});
exports.injectCustomerProductDetails = injectCustomerProductDetails;
const injectProductDetailsErrors = detailsErrors => dispatch => {
  const detailsWithErrors = Object.entries(detailsErrors).filter(_ref12 => {
    let [, error] = _ref12;
    return error;
  });

  // errors are always the same, just find one
  const [, detailsError] = detailsWithErrors.find(_ref13 => {
    let [, error] = _ref13;
    return error;
  }) || [];
  if (detailsError) {
    dispatch({
      type: LOAD_DETAILS_ERROR,
      types: detailsWithErrors.map(_ref14 => {
        let [type] = _ref14;
        return type;
      }),
      error: detailsError
    });
  }
};
exports.injectProductDetailsErrors = injectProductDetailsErrors;
var _default = reducer;
exports.default = _default;